<template>
    <ion-infinite-scroll v-if="hasShow()" threshold="100px" @ionInfinite="loadMore($event)" >
        <ion-infinite-scroll-content
                loadingSpinner="bubbles"
                loadingText="Loading more data...">
        </ion-infinite-scroll-content>
    </ion-infinite-scroll>
</template>
<script>
    import EventBus from "@/utils/event-bus";
    export default {
        name: 'LazyloadLoadingLayout',
        mixins: [],
        components: {
        },
        props: {
            paginationData: {
                type: Object,
                default: {
                    total: 0,
                    page: 0,
                    size: 0,
                }
            },
            setPage: {
                type: Function,
                default: () => {}
			},
            setData: {
                type: Function,
                default: () => {},
            },
            type: {},
            listLength: {
                type: Number,
                default: 0
            }
        },
        data() {
            return{

            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods: {
            loadMore($event) {
                let page= this.paginationData.page;
                if(this.type === 'pre') {
                    this.setData('hasPre', true);
                    page = page - 1;
                }else{
                    page = page + 1;
                }
				this.setPage('page', page);
                EventBus.$emit('getBoardList')
                setTimeout(() => {
                    if(this.type === 'pre' && page === 1) {
                        $event.target.complete();
                    }else if(this.paginationData.total > page) {
                        $event.target.complete();
                    }else{
                        $event.target.disabled = true;
                    }
                }, 500)
            },
            hasShow() {
                if(this.paginationData.total === 0) {
                    return false;
                }
                if(this.type === 'pre') {
                    return this.typePreReturnStatue();
                }else{
                    return this.typeNextReturnStatus();
                }

            },
            typePreReturnStatue() {
                if(this.paginationData.page > 1 && this.listLength < this.paginationData.page * this.paginationData.size) {
                    return true;
                }else{
                    return false;
                }
            },
            typeNextReturnStatus() {
                if(this.paginationData.total > 0 && this.paginationData.total > this.paginationData.page * this.paginationData.size) {
                    return true;
                }else{
                    return false;
                }
            },
        },
        watch: {

        },
    }
</script>